import {Injectable} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms'
import {EMAIL_PATTERN, PHONE_NUMBER_PATTERN} from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class GetShippingFormsService {

  constructor(private fb: FormBuilder) {
  }



  getFilterShippings(): FormGroup {
    return this.fb.group({
      siteName: [],
      name: [],
      type: this.fb.group({ id: [null], name: [null] }),
      transporterName: this.fb.group({ id: [null], name: [null] }),
      tracking: [] ,
      countryCode: this.fb.group({ code: [null], name: [null] }),
      deliveryStatus: [],
      pickupDate: [],
      deliveryDate: [],
      orderId: [],
    });
  }

  getShipping(): FormGroup {
      return this.fb.group({
        address: this.getAddress(),
        general: this.fb.group({
          clientName: [null , Validators.required],
          clientUuid: [null , Validators.required],
          siteName: [],
          siteUuid: [],
        }),
        misc: this.fb.group({
          commentsForm: this.fb.group({
            commentsBlog: [null],
            comments: [null]
          }),
          byForm: this.fb.group({
            updatedBy: [null],
            createdBy: [null]
          }),
        }),
        contact: this.getContact(),
        sendingType: this.fb.group({
          type: this.fb.group({ id: [null , Validators.required], name: [null] }),
          transporter: this.fb.group({ id: [null , Validators.required], name: [null] }),
          name: [null, [Validators.required, Validators.maxLength(250)]],
          tracking: [null , [Validators.required, Validators.maxLength(50)]],
          deliveryDate: [null],
          deliveryStatus: [null],
          pickupDate: [null , Validators.required],
        }),
        billing: this.fb.group({
          cost: [null],
          tax: [null],
          analyticCode: this.fb.group({ id: [null , Validators.required], name: [null] }),
          office: this.fb.group({ id: [null , Validators.required], name: [null] }),
          invoice: [null],
        }),
        uuid: [null],
        created: [null],
        updated: [null],
        id: [null],
        displayName: [null],
      })
    };
  getAddress(): FormGroup {
    return this.fb.group({
      countryForm: this.fb.group({
        name: [null, Validators.required]
      }),
      country: [null],
      created: [null],
      createdBy: [null],
      id: [null],
      line1: [null, Validators.required],
      line2: [null],
      line3: [null],
      name: [null],
      state: [null],
      city: [null, Validators.required],
      updated: [null],
      updatedBy: [null],
      uuid: [null],
      zip: [null, Validators.required],
      isSaveAddress: [null],
      addressType: [null],
    })
  }

  getItem(): FormGroup {
    return this.fb.group({
      name: [null],
      uuid: [null , Validators.required],
    });
  }
  getContact(): FormGroup {
    return this.fb.group({
      comments: [null],
      culture: [null],
      created: [null],
      createdBy: [null],
      department: [null],
      email: [null, [Validators.required, Validators.pattern(EMAIL_PATTERN)]],
      groupRole: [null],
      id: [null],
      mobile: [null],
      name: [null, Validators.required],
      phone: [null, [Validators.required, Validators.pattern(PHONE_NUMBER_PATTERN)]],
      sex: [null],
      skype: [null],
      surname: [null, Validators.required],
      typeUser: [null],
      uuid: [null],
      updated: [null],
      updatedBy: [null]
    })
  }
}


